<template>
	<div>
		<v-data-table
			v-if="hasItens"
			v-model="itensParaAdicionarNaAta"
			:headers="colunas"
			:items="itensAdicionarAta"
			show-select
			item-key="id"
			hide-default-footer
			:server-items-length="totalItens"
			:options="paginacaoInterna"
			class="arp-listview mt-5 row-pointer"
		>
			<template #[`header.data-table-select`]="{ props, on }">
				<v-simple-checkbox
					:value="props.value || props.indeterminate"
					:indeterminate="props.indeterminate"
					color="primary"
					v-on="on"
				></v-simple-checkbox>
			</template>
			<template #[`item.data-table-select`]="{ isSelected, select }">
				<v-simple-checkbox
					id="caixaDeSelecao"
					class="row-checkbox"
					color="primary"
					:value="isSelected"
					@input="select($event)"
					@click.stop
				></v-simple-checkbox>
			</template>
			<template #item.razaoSocial="{ item }">
				<texto-tooltip
					:texto="montarDescricaoFornecedor(item.documento, item.razaoSocial)"
					:tamanho-maximo="textoTamanhoMaximo"
				></texto-tooltip>
			</template>
			<template #item.numeroEdital="{ item }">
				<span> {{ item.numeroEdital }} </span>
			</template>
			<template #item.tipoAta="{ item }">
				<span> {{ item.loteNumero }} </span>
				<span v-show="item.quantidadeLotes > quantidadeMaxDeLotes"> e </span>
				<a
					class="font-weight-bold"
					v-show="item.quantidadeLotes > quantidadeMaxDeLotes"
					@click="abrirModalComItemTipoSelecionado(montarFiltroModalLote(item))"
				>
					+{{ item.quantidadeLotes - 1 }}
				</a>
			</template>
		</v-data-table>

		<template-listagem-vazia
			:total-itens="totalItens"
			:textos="textosDoTemplateDaListagemVazia"
		></template-listagem-vazia>

		<paginacao-tabela
			v-if="hasItens"
			:page.sync="paginacaoInterna.page"
			:rows-per-page.sync="paginacaoInterna.rowsPerPage"
			:totalPaginas="totalPaginas"
			:totalItens="totalItens"
			@resetar-page="resetarPage"
		></paginacao-tabela>

		<modal
			:max-width="modalItemProcessoLotesOptions.largura"
			:max-height="modalItemProcessoLotesOptions.altura"
			:exibir="modalItemProcessoLotesOptions.exibir"
			:titulo="modalItemProcessoLotesOptions.tituloModal"
			@close="fecharModal"
		>
			<template #body>
				<v-row class="pt-5">
					<div
						v-for="(lote, index) in lotesDaModal(modalItemProcessoLotesOptions.datasource)"
						:key="index"
						class="ma-2"
					>
						<v-tooltip top>
							<template #activator="{ on }">
								<v-chip color="grey lighten-3" label v-on="on">{{ lote.tituloFormatado }}</v-chip>
							</template>
							<span>{{ lote.tituloFormatado }}</span>
						</v-tooltip>
					</div>
				</v-row>
			</template>
		</modal>
	</div>
</template>

<script>
import { TabelaColunaUtils } from '@/core/utils'
import tabelaMixin from '@/views/mixins/tabela'
import mutationTypes from '@/core/constants/mutation-types'
import { actionTypes } from '@/core/constants'

export default {
	name: 'modal-adicionar-item-listagem',
	mixins: [tabelaMixin],
	props: {
		itensAdicionarAta: {
			type: Array,
			required: true,
		},
	},
	data() {
		return {
			colunas: [
				new TabelaColunaUtils('Fornecedor', 'razaoSocial', '50%'),
				new TabelaColunaUtils('Tipo', 'tipoAta', '25%'),
			],
			modalItemProcessoLotesOptions: {
				largura: '30%',
				altura: '50%',
				tituloModal: 'Tipos',
				datasource: [],
				idItemProcesso: null,
				exibir: false,
			},
			paginacaoInterna: this.paginacao,
			filtroMascaraCNPJ: this.$options.filters.azCpfCnpj,
			textoTamanhoMaximo: 80,
			textosDoTemplateDaListagemVazia: {
				titulo: 'Nenhum item de processo está disponível para ser adicionado.',
			},
			quantidadeMaxDeLotes: 1,
		}
	},
	computed: {
		itensParaAdicionarNaAta: {
			get() {
				return this.$store.state.itemAta.itensParaAdicionarNaAta
			},
			async set(value) {
				await this.montarLotesEmCadaItemProcesso(value)
			},
		},
	},
	methods: {
		lotesDaModal: (lotes) => {
			return lotes.filter((item) => {
				return item.isVisible
			})
		},
		buscarLotesPorProcessoSelecionado(filtroModalLoteSelecionado) {
			this.$store.commit(mutationTypes.TIPO.POR_NUMERO_E_ITEM_PROCESSO.SET_FILTRO, filtroModalLoteSelecionado)
			return this.$store.dispatch(actionTypes.TIPO.POR_NUMERO_E_ITEM_PROCESSO.BUSCAR_TIPOS_POR_NUMERO_E_PROCESSO)
		},
		async abrirModalComItemTipoSelecionado(item) {
			this.modalItemProcessoLotesOptions.exibir = true
			this.modalItemProcessoLotesOptions.idItemProcesso = item.idProcesso
			await this.montarModalDeLotesPorProcessoSelecionado(this.montarFiltroModalLote(item))
		},
		async montarLotesEmCadaItemProcesso(array) {
			for (const item of array) {
				if (!item.idLotes || item.idLotes.length === 0) {
					const { itens } = await this.buscarLotesPorProcessoSelecionado(this.montarFiltroModalLote(item))
					item.idLotes = this.getIdsLotes(itens)
				}
				item.idItensNaoAdicionados = []
			}

			this.$store.commit(mutationTypes.ITEM_ATA.SET_ITENS_ARRAY_PARA_ADICIONAR, array)
		},
		async montarModalDeLotesPorProcessoSelecionado(filtroModalLoteSelecionado) {
			const { itens } = await this.buscarLotesPorProcessoSelecionado(filtroModalLoteSelecionado)
			this.modalItemProcessoLotesOptions.datasource = itens.map((item) => {
				item.isVisible = item.numero !== filtroModalLoteSelecionado.loteNumero
				return item
			})
		},
		montarFiltroModalLote(item) {
			return {
				loteNumero: item.loteNumero,
				idProcesso: item.idProcesso,
				idFornecedor: item.idFornecedor,
				numeroEdital: item.numeroEdital,
				isUsadoEmAta: false,
			}
		},
		montarDescricaoFornecedor(cnpj, descricaoFornecedor) {
			return `${this.filtroMascaraCNPJ(cnpj)} - ${descricaoFornecedor}`
		},
		getIdsLotes(lotes) {
			return lotes.map((item) => {
				return item.id
			})
		},
		resetarPage() {
			this.$emit('resetar-page')
		},
		fecharModal() {
			this.modalItemProcessoLotesOptions.exibir = false
			this.$emit('fechar-modal')
		},
	},
}
</script>
<style lang="stylus">
.arp_icon_and_text
	> i
		margin-right 2px


.arp_icone_fornecedor
	background-color: #e9e9e9;
	border-radius: 50%;
	padding: 2px 2px;
	color: var(--v-primary-base);
	float: left;
	margin-right: 5px;
	font-size: 15px !important;

.item-container
	display: flex;
	align-items: center;


.item-container span
	margin-left: 10px;

/* ajuste a margem como preferir */

.arp-vlist
	margin-bottom: 15px !important
</style>
